<template>
  <div class="recommended">
    <search-layout>
      <div class="item">
        <label>歌曲名称：</label>
        <div class="input">
          <a-input
            placeholder="请输入歌曲名称"
            size="large"
            v-model:value="params.name"
          />
        </div>
      </div>
      <div class="item">
        <label>演唱者：</label>
        <div class="input">
          <a-input
            placeholder="请输入演唱者"
            size="large"
            v-model:value="params.singer"
          />
        </div>
      </div>
      <div class="item">
        <label>是否上架：</label>
        <a-select size="large" v-model:value="params.status">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">上架</a-select-option>
          <a-select-option value="0">下架</a-select-option>
        </a-select>
      </div>
      <!-- <div class="item">
        <label>推荐日期：</label>
       
         <a-range-picker size="large" @change="change" format="YYYY/MM/DD" />
      </div> -->
      <template #button>
        <a-button type="primary" size="large" @click="search">搜索</a-button>
      </template>
    </search-layout>
    <table-layout>
      <a-table
        :dataSource="list"
        :columns="columns"
        :pagination="pagination"
        rowKey="id"
        :scroll="{ y: true }"
        @change="handleTableChange"
      >
        <template #name="{record}">
          {{ record.song.name }}
        </template>
        <template #singer="{record}">
          {{ record.song.song }}
        </template>
        <template #nickname="{record}">
          {{ record.user.nickname }}
        </template>
        <template #status="{record}">
          <span :class="record.status ? '' : 'red'">
            {{ record.status ? "正常" : "已删除" }}
          </span>
        </template>
        <template #operator="{record}">
          {{
            record.operator
              ? record.userId === record.operator
                ? record.user.nickname
                : record.operator
              : "--"
          }}
        </template>

        <template #time="{ record }">
          {{ record.updatedAt == record.createdAt ? "--" : record.updatedAt }}
        </template>
        <template #action="{ record }">
          <a-button
            class="mar"
            type="primary"
            size="small"
            v-if="!(record.userId === record.operator && !record.status)"
            @click="modify(record)"
            >{{ record.status ? "删除" : "取消删除" }}</a-button
          >
        </template>
      </a-table>
    </table-layout>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, ref } from "vue";
import searchLayout from "@/layout/search";
import tableLayout from "@/layout/table";
import columns from "./columns";
import { getReview, updateReview } from "@/api/song";

import { message } from "ant-design-vue";
export default {
  components: {
    searchLayout,
    tableLayout,
  },
  setup() {
    const formRef = ref();
    const state = reactive({
      status: "",
      list: [],
      date: "",
      visible: false,

      pagination: {
        total: 0,
      },
      params: {
        limit: 10,
        offset: 0,
        name: "",
        singer: "",
        status: "",
      },
    });

    const modify = ({ id, status }) => {
      updateReview(id, {
        status: status == 1 ? 0 : 1,
        operator: localStorage.getItem('username')
      }).then(() => {
        message.success("修改成功");
        init();
      });
    };
    const init = () => {
      getReview(state.params).then((res) => {
        state.list = res.rows;
        state.pagination.total = res.count;
      });
    };
    const search = () => {
      state.params.offset = 0;

      init();
    };

    const handleTableChange = ({ current }) => {
      state.params.offset = (current - 1) * state.params.limit;
      init();
    };
    onMounted(() => {
      init();
    });
    return {
      ...toRefs(state),
      columns,
      modify,
      search,
      formRef,
      open,
      handleTableChange,
    };
  },
};
</script>

<style lang="less">
.recommended {
  height: 100%;
  overflow: hidden;
  .mar {
    margin: 0 10px;
  }
}
</style>
